import React, { useState, useRef } from "react";
import emailjs from "@emailjs/browser";

const COUNTRY_CODES = [
  { code: "+1", country: "US", maxLen: 10 },
  { code: "+1", country: "CA", maxLen: 10 },
  { code: "+7", country: "RU", maxLen: 10 },
  { code: "+20", country: "EG", maxLen: 10 },
  { code: "+27", country: "ZA", maxLen: 9 },
  { code: "+30", country: "GR", maxLen: 10 },
  { code: "+31", country: "NL", maxLen: 9 },
  { code: "+32", country: "BE", maxLen: 9 },
  { code: "+33", country: "FR", maxLen: 9 },
  { code: "+34", country: "ES", maxLen: 9 },
  { code: "+36", country: "HU", maxLen: 9 },
  { code: "+39", country: "IT", maxLen: 10 },
  { code: "+40", country: "RO", maxLen: 10 },
  { code: "+41", country: "CH", maxLen: 9 },
  { code: "+43", country: "AT", maxLen: 10 },
  { code: "+44", country: "GB", maxLen: 10 },
  { code: "+45", country: "DK", maxLen: 8 },
  { code: "+46", country: "SE", maxLen: 9 },
  { code: "+47", country: "NO", maxLen: 8 },
  { code: "+48", country: "PL", maxLen: 9 },
  { code: "+49", country: "DE", maxLen: 11 },
  { code: "+51", country: "PE", maxLen: 9 },
  { code: "+52", country: "MX", maxLen: 10 },
  { code: "+53", country: "CU", maxLen: 8 },
  { code: "+54", country: "AR", maxLen: 10 },
  { code: "+55", country: "BR", maxLen: 11 },
  { code: "+56", country: "CL", maxLen: 9 },
  { code: "+57", country: "CO", maxLen: 10 },
  { code: "+58", country: "VE", maxLen: 10 },
  { code: "+60", country: "MY", maxLen: 10 },
  { code: "+61", country: "AU", maxLen: 9 },
  { code: "+62", country: "ID", maxLen: 12 },
  { code: "+63", country: "PH", maxLen: 10 },
  { code: "+64", country: "NZ", maxLen: 9 },
  { code: "+65", country: "SG", maxLen: 8 },
  { code: "+66", country: "TH", maxLen: 9 },
  { code: "+81", country: "JP", maxLen: 10 },
  { code: "+82", country: "KR", maxLen: 10 },
  { code: "+84", country: "VN", maxLen: 10 },
  { code: "+86", country: "CN", maxLen: 11 },
  { code: "+90", country: "TR", maxLen: 10 },
  { code: "+91", country: "IN", maxLen: 10 },
  { code: "+92", country: "PK", maxLen: 10 },
  { code: "+93", country: "AF", maxLen: 9 },
  { code: "+94", country: "LK", maxLen: 9 },
  { code: "+95", country: "MM", maxLen: 9 },
  { code: "+98", country: "IR", maxLen: 10 },
  { code: "+212", country: "MA", maxLen: 9 },
  { code: "+213", country: "DZ", maxLen: 9 },
  { code: "+216", country: "TN", maxLen: 8 },
  { code: "+218", country: "LY", maxLen: 9 },
  { code: "+220", country: "GM", maxLen: 7 },
  { code: "+221", country: "SN", maxLen: 9 },
  { code: "+233", country: "GH", maxLen: 9 },
  { code: "+234", country: "NG", maxLen: 10 },
  { code: "+254", country: "KE", maxLen: 9 },
  { code: "+255", country: "TZ", maxLen: 9 },
  { code: "+256", country: "UG", maxLen: 9 },
  { code: "+260", country: "ZM", maxLen: 9 },
  { code: "+263", country: "ZW", maxLen: 9 },
  { code: "+351", country: "PT", maxLen: 9 },
  { code: "+352", country: "LU", maxLen: 9 },
  { code: "+353", country: "IE", maxLen: 9 },
  { code: "+358", country: "FI", maxLen: 10 },
  { code: "+380", country: "UA", maxLen: 9 },
  { code: "+381", country: "RS", maxLen: 9 },
  { code: "+385", country: "HR", maxLen: 9 },
  { code: "+386", country: "SI", maxLen: 8 },
  { code: "+420", country: "CZ", maxLen: 9 },
  { code: "+421", country: "SK", maxLen: 9 },
  { code: "+852", country: "HK", maxLen: 8 },
  { code: "+853", country: "MO", maxLen: 8 },
  { code: "+855", country: "KH", maxLen: 9 },
  { code: "+856", country: "LA", maxLen: 9 },
  { code: "+880", country: "BD", maxLen: 10 },
  { code: "+886", country: "TW", maxLen: 9 },
  { code: "+960", country: "MV", maxLen: 7 },
  { code: "+961", country: "LB", maxLen: 8 },
  { code: "+962", country: "JO", maxLen: 9 },
  { code: "+963", country: "SY", maxLen: 9 },
  { code: "+964", country: "IQ", maxLen: 10 },
  { code: "+965", country: "KW", maxLen: 8 },
  { code: "+966", country: "SA", maxLen: 9 },
  { code: "+967", country: "YE", maxLen: 9 },
  { code: "+968", country: "OM", maxLen: 8 },
  { code: "+971", country: "AE", maxLen: 9 },
  { code: "+972", country: "IL", maxLen: 9 },
  { code: "+973", country: "BH", maxLen: 8 },
  { code: "+974", country: "QA", maxLen: 8 },
  { code: "+975", country: "BT", maxLen: 8 },
  { code: "+976", country: "MN", maxLen: 8 },
  { code: "+977", country: "NP", maxLen: 10 },
];

const COUNTRY_MAP = Object.fromEntries(COUNTRY_CODES.map(c => [c.country, c]));
const UNIQUE_CODES = [...new Map(COUNTRY_CODES.map(c => [`${c.code}-${c.country}`, c])).values()]
  .sort((a, b) => a.country.localeCompare(b.country));

const MIN_PHONE_LEN = 6;

const EMAILJS_SERVICE_ID = "service_a5fn9g9";
const EMAILJS_TEMPLATE_ID = "template_aifi1oz";
const EMAILJS_AUTOREPLY_TEMPLATE_ID = "template_6up9yw5";
const EMAILJS_PUBLIC_KEY = "_DB4vWz9zrXHpkqCs";

const INQUIRY_CATEGORIES = [
  "AI & Intelligent Automation",
  "Cloud Engineering & Migration",
  "Digital Transformation Strategy",
  "Enterprise App Development",
  "Custom Software & Web Solutions",
  "UI/UX Modernization",
  "Managed IT & Customer Support",
  "Others",
];

const OPTIONAL_FIELDS = ["budget", "timeline", "details"];

const FIELDS = [
  { name: "fullName", label: "Full Name", type: "text", placeholder: "e.g., John Doe" },
  { name: "company", label: "Organization Name", type: "text", placeholder: "Enter your legal entity or company name" },
  { name: "email", label: "Business Email", type: "email", placeholder: "e.g., name@company.com" },
  { name: "projectType", label: "Inquiry Category", type: "select", placeholder: "Select the service you require" },
  { name: "budget", label: "Estimated Investment (Optional)", type: "number", placeholder: "e.g., 10000" },
  { name: "timeline", label: "Target Launch Date (Optional)", type: "date", placeholder: "" },
  { name: "details", label: "Scope of Work (Optional)", type: "textarea", placeholder: "Briefly describe your objectives, tech stack, or challenges." },
];

const TRUST_BADGES = [
  "NDAs available upon request",
  "Secure Data Encryption",
  "Response within 24 business hours",
];

export default function ContactForm({ title }) {
  const [form, setForm] = useState({
    fullName: "", company: "", email: "", phone: "",
    countryCode: "IN", projectType: "", budget: "", timeline: "", details: "",
  });
  const [errors, setErrors] = useState({});
  const [snackbar, setSnackbar] = useState({ show: false, message: "", type: "" });
  const [loading, setLoading] = useState(false);
  const refs = useRef({});
  const formRef = useRef(null);

  const selectedCountry = COUNTRY_MAP[form.countryCode] || COUNTRY_MAP["IN"];
  const maxLen = selectedCountry.maxLen;

  const showSnackbar = (message, type) => {
    setSnackbar({ show: true, message, type });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: "" }));
  };

  const handleCountryChange = (e) => {
    const country = e.target.value;
    setForm(prev => ({ ...prev, countryCode: country, phone: "" }));
    if (errors.phone) setErrors(prev => ({ ...prev, phone: "" }));
  };

  const handlePhoneChange = (e) => {
    const val = e.target.value.replace(/[^0-9]/g, "").slice(0, maxLen);
    setForm(prev => ({ ...prev, phone: val }));
    if (errors.phone) setErrors(prev => ({ ...prev, phone: "" }));
  };

  const handleBudgetChange = (e) => {
    const val = e.target.value.replace(/[^0-9]/g, "");
    setForm(prev => ({ ...prev, budget: val }));
    if (errors.budget) setErrors(prev => ({ ...prev, budget: "" }));
  };

  const todayDate = new Date().toISOString().split("T")[0];

  const allFields = [...FIELDS.slice(0, 3), { name: "phone", label: "Contact Number" }, ...FIELDS.slice(3)];

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};

    for (const f of allFields) {
      const val = form[f.name]?.trim();
      if (!val && !OPTIONAL_FIELDS.includes(f.name)) {
        newErrors[f.name] = `${f.label} is required`;
        setErrors(newErrors);
        refs.current[f.name]?.focus();
        return;
      }
      if (f.name === "email" && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) {
        newErrors[f.name] = "Enter a valid email address";
        setErrors(newErrors);
        refs.current[f.name]?.focus();
        return;
      }
      if (f.name === "phone") {
        if (val.length < MIN_PHONE_LEN) {
          newErrors[f.name] = `Minimum ${MIN_PHONE_LEN} digits required`;
          setErrors(newErrors);
          refs.current[f.name]?.focus();
          return;
        }
        if (val.length > maxLen) {
          newErrors[f.name] = `Maximum ${maxLen} digits for ${form.countryCode}`;
          setErrors(newErrors);
          refs.current[f.name]?.focus();
          return;
        }
      }
    }

    setErrors({});
    setLoading(true);

    try {
      const templateParams = {
        fullName: form.fullName,
        company: form.company,
        email: form.email,
        phone: `${selectedCountry.code} ${form.phone}`,
        projectType: form.projectType,
        budget: form.budget,
        timeline: form.timeline,
        details: form.details,
      };

      await emailjs.send(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, templateParams, EMAILJS_PUBLIC_KEY);
      emailjs.send(EMAILJS_SERVICE_ID, EMAILJS_AUTOREPLY_TEMPLATE_ID, templateParams, EMAILJS_PUBLIC_KEY);
      showSnackbar("Your consultation request has been sent successfully!", "success");
      setForm(prev => ({
        fullName: "", company: "", email: "", phone: "",
        countryCode: prev.countryCode, projectType: "", budget: "", timeline: "", details: "",
      }));
    } catch (error) {
      console.error("EmailJS error:", error);
      showSnackbar("Failed to send your request. Please try again.", "error");
    } finally {
      setLoading(false);
    }
  };

  const renderField = (f, full = false) => (
    <div className={`form-group${full ? " full" : ""}`} key={f.name}>
      <label>{f.label}</label>
      {f.type === "select" ? (
        <select
          name={f.name}
          value={form[f.name]}
          onChange={handleChange}
          ref={el => (refs.current[f.name] = el)}
          className={`${errors[f.name] ? "input-error" : ""}${!form[f.name] ? " select-placeholder" : ""}`}
        >
          <option value="" disabled hidden>{f.placeholder}</option>
          {INQUIRY_CATEGORIES.map(t => (
            <option key={t} value={t}>{t}</option>
          ))}
        </select>
      ) : f.type === "textarea" ? (
        <textarea
          name={f.name}
          rows="4"
          placeholder={f.placeholder}
          value={form[f.name]}
          onChange={handleChange}
          ref={el => (refs.current[f.name] = el)}
          className={errors[f.name] ? "input-error" : ""}
        />
      ) : (
        <input
          name={f.name}
          type={f.type}
          placeholder={f.placeholder}
          value={form[f.name]}
          onChange={f.name === "budget" ? handleBudgetChange : handleChange}
          ref={el => (refs.current[f.name] = el)}
          className={errors[f.name] ? "input-error" : ""}
          {...(f.type === "date" ? { min: todayDate } : {})}
          {...(f.type === "number" ? { min: "0" } : {})}
        />
      )}
      {errors[f.name] && <span className="helper-text">{errors[f.name]}</span>}
    </div>
  );

  const handleSnackbarClose = () => {
    setSnackbar({ show: false, message: "", type: "" });
  };

  // Auto-dismiss after 4 seconds
  React.useEffect(() => {
    if (!snackbar.show) return;
    const timer = setTimeout(() => setSnackbar({ show: false, message: "", type: "" }), 4000);
    return () => clearTimeout(timer);
  }, [snackbar.show]);

  return (
    <>
      <section className="section form-section">
        <h2>{title || "The Intelligence Form"}</h2>
      <form className="intel-form" ref={formRef} onSubmit={handleSubmit} noValidate>
        <div className="form-row">
          {renderField(FIELDS[0])}
          {renderField(FIELDS[1])}
        </div>
        <div className="form-row">
          {renderField(FIELDS[2])}
          <div className="form-group">
            <label>Contact Number</label>
            <div className={`phone-input-wrap${errors.phone ? " phone-input-error" : ""}`}>
              <select
                name="countryCode"
                value={form.countryCode}
                onChange={handleCountryChange}
                className="phone-code-select"
              >
                {UNIQUE_CODES.map(c => (
                  <option key={c.country} value={c.country}>
                    {c.country} {c.code}
                  </option>
                ))}
              </select>
              <input
                name="phone"
                type="tel"
                placeholder="Enter mobile or office number"
                value={form.phone}
                onChange={handlePhoneChange}
                maxLength={maxLen}
                ref={el => (refs.current.phone = el)}
                className="phone-number-input"
              />
            </div>
            {errors.phone && <span className="helper-text">{errors.phone}</span>}
          </div>
        </div>
        {renderField(FIELDS[3], true)}
        {renderField(FIELDS[4], true)}
        {renderField(FIELDS[5], true)}
        {renderField(FIELDS[6], true)}
        <button type="submit" className="btn-submit" disabled={loading}>
          {loading ? 'Sending...' : 'Request Consultation'}
        </button>
        <div className="form-trust-badges">
          {TRUST_BADGES.map((badge, i) => (
            <span key={i} className="trust-badge">✓ {badge}</span>
          ))}
        </div>
      </form>
      </section>

      {snackbar.show && (
        <div className={`custom-snackbar custom-snackbar-${snackbar.type}`}>
          <span className="custom-snackbar-icon">{snackbar.type === "success" ? "✓" : "✕"}</span>
          <span className="custom-snackbar-msg">{snackbar.message}</span>
          <button className="custom-snackbar-close" onClick={handleSnackbarClose}>✕</button>
        </div>
      )}
    </>
  );
}
